import { Suspense } from 'react';
import { lazyWithRetry } from './lib/lazyWithRetry.js';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './auth/AuthProvider.jsx';
import { TenantProvider } from './tenant/TenantProvider.jsx';
import { RequireAuth } from './auth/RequireAuth.jsx';
import { RequireRole } from './auth/RequireRole.jsx';
import { RequireTerms } from './auth/RequireTerms.jsx';
import { ErrorBoundary } from './components/ErrorBoundary.jsx';
import InstallPrompt from './components/InstallPrompt.jsx';
import UpdatePrompt from './components/UpdatePrompt.jsx';
import RouteMemory from './components/RouteMemory.jsx';
import Login from './pages/Login.jsx';
import Landing from './pages/Landing.jsx';
import AuthAction from './pages/AuthAction.jsx';
import Terms from './pages/Terms.jsx';
import Privacy from './pages/Privacy.jsx';
import About from './pages/About.jsx';
import Contact from './pages/Contact.jsx';
import Changelog from './pages/Changelog.jsx';
import Pricing from './pages/Pricing.jsx';
import Learn from './pages/Learn.jsx';
import LearnArticle from './pages/LearnArticle.jsx';
import NotFound from './pages/NotFound.jsx';
import TV from './pages/TV.jsx';
const MemberShell = lazyWithRetry(() => import('./pages/member/MemberShell.jsx'));
const AdminShell = lazyWithRetry(() => import('./pages/admin/AdminShell.jsx'));
const TrainerShell = lazyWithRetry(() => import('./pages/trainer/TrainerShell.jsx'));
const PlatformShell = lazyWithRetry(() => import('./pages/platform/PlatformShell.jsx'));

export default function App() {
  return (
    <ErrorBoundary>
    <AuthProvider>
      <TenantProvider>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/auth/action" element={<AuthAction />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/changelog" element={<Changelog />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/learn" element={<Learn />} />
          <Route path="/learn/:slug" element={<LearnArticle />} />
          <Route path="/tv" element={<TV />} />

          <Route
            path="/app/*"
            element={
              <RequireAuth>
                <RequireRole allow={['member', 'trainer', 'owner', 'platform-admin']}>
                  <RequireTerms>
                    <Suspense fallback={null}><MemberShell /></Suspense>
                  </RequireTerms>
                </RequireRole>
              </RequireAuth>
            }
          />
          <Route
            path="/platform/*"
            element={
              <RequireAuth>
                <RequireRole allow={['platform-admin']}>
                  <Suspense fallback={null}><PlatformShell /></Suspense>
                </RequireRole>
              </RequireAuth>
            }
          />
          <Route
            path="/admin/*"
            element={
              <RequireAuth>
                <RequireRole allow={['owner', 'platform-admin']}>
                  <Suspense fallback={null}><AdminShell /></Suspense>
                </RequireRole>
              </RequireAuth>
            }
          />
          <Route
            path="/trainer/*"
            element={
              <RequireAuth>
                <RequireRole allow={['trainer', 'owner', 'platform-admin']}>
                  <RequireTerms>
                    <Suspense fallback={null}><TrainerShell /></Suspense>
                  </RequireTerms>
                </RequireRole>
              </RequireAuth>
            }
          />

          <Route path="*" element={<NotFound />} />
        </Routes>
      </TenantProvider>
    </AuthProvider>
    <RouteMemory />
    <InstallPrompt />
    <UpdatePrompt />
    </ErrorBoundary>
  );
}
